import { useEffect, useState } from 'react';
const useWindowOrientation = () => {
    const [portrait, setPortrait] = useState(true);
    useEffect(() => {
        const handler = () => {
            var _a;
            const angle = ((_a = screen.orientation) === null || _a === void 0 ? void 0 : _a.angle) || window.orientation;
            if (90 === angle || -90 === angle) {
                setPortrait(false);
            }
            else {
                setPortrait(true);
            }
        };
        handler();
        window.addEventListener('orientationchange', handler, false);
        () => window.removeEventListener('orientationchange', handler);
    }, []);
    return portrait;
};
export default useWindowOrientation;
